import { getBorderStyle, getBorderWidth } from './border';
import { getBorderRadius } from './border-radius';
import { getShadow } from './shadow';

import type { AdvancedStyling, AdvancedTextTransform } from '$lib/types/Theming/AdvancedStyling';

const TEXT_TRANSFORM_CLASSES: Record<AdvancedTextTransform, string> = {
    none: 'fun-normal-case',
    uppercase: 'fun-uppercase',
    lowercase: 'fun-lowercase',
    capitalize: 'fun-capitalize',
};

export interface AdvancedStylingClasses {
    borderRadius: string | undefined;
    shadow: string | undefined;
    borderWidth: string | undefined;
    borderStyle: string | undefined;
    textTransform: string | undefined;
}

interface Options {
    // Which shadow scale key to look up in shadow.ts (maps to component → scale A/B/C).
    shadowComponent: Parameters<typeof getShadow>[0];
    // Which border-radius scale key to look up in border-radius.ts.
    borderRadiusComponent: Parameters<typeof getBorderRadius>[0];
}

// Returns Tailwind class strings for the structural fields of AdvancedStyling. Color fields
// (borderColor, etc.) are applied inline and are not part of this helper.
export const getAdvancedStylingClasses = (
    styling: AdvancedStyling | undefined,
    { shadowComponent, borderRadiusComponent }: Options,
): AdvancedStylingClasses => ({
    borderRadius: styling?.borderRadius
        ? getBorderRadius(borderRadiusComponent, styling.borderRadius)
        : undefined,
    shadow: styling?.shadow ? getShadow(shadowComponent, styling.shadow) : undefined,
    borderWidth: styling?.borderWidth ? getBorderWidth(styling.borderWidth) : undefined,
    borderStyle: styling?.borderStyle ? getBorderStyle(styling.borderStyle) : undefined,
    textTransform: styling?.textTransform
        ? TEXT_TRANSFORM_CLASSES[styling.textTransform]
        : undefined,
});
